export default __webpack_public_path__ + "static/media/Strasbourg.87aec619.png";